import { OpenIdConfiguration, LogLevel } from 'angular-auth-oidc-client';
import { inject } from '@angular/core';
import { OidcPrefixedStorageService } from './oidc-prefixed-storage.service';
import { environment } from '../../../environments/environment';

//Configuration for OpenID Connect authentication
export const authConfig: OpenIdConfiguration = {
  authority: environment.NmdpConfig.authority,
  clientId: environment.NmdpConfig.clientId,
  redirectUrl: environment.ehr_redirect_url,
  postLogoutRedirectUri: window.location.origin,
  postLoginRoute: '/landing',
  scope: `openid ${Array.isArray(environment.NmdpConfig.scope) ? environment.NmdpConfig.scope.join(' ') : JSON.parse(environment.NmdpConfig.scope).join(' ')}`,
  responseType: environment.NmdpConfig.responseType,
  //silentRenew: false,
  //silentRenewUrl: `${window.location.origin}/silent-renew.html`,
  useRefreshToken: environment.NmdpConfig.useRefreshToken,
  renewTimeBeforeTokenExpiresInSeconds: 60,
  autoUserInfo: true,
  historyCleanupOff: true,
  disableIdTokenValidation: false,
  customParamsAuthRequest: {
    prompt: 'login'
  },
  logLevel: LogLevel.Error
};